import RedirectToLockersOrDeliveries from '@/mixins/redirect-to-lockers-or-deliveries.js'

export default {
  name: 'OktaSetup',
  mixins: [RedirectToLockersOrDeliveries],
  methods: {
    goLockers() {
      if (this.currentUser) this.redirectToLockersOrDeliveries()
    },
  },
}
